import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static get targets() {
    return ["select", "selectedOption", "list", "tagTemplate", "selectedOptionTemplate", "submitButton", "button"]
  }

  static get values() {
    return {
      proposals: { type: Array, default: [] },
      selected: { type: Array, default: [] }
    }
  }

  connect() {
    this.draftValues = []

    const self = this
    $(this.selectTarget).selectize({
      create: true,
      openOnFocus: false,
      setFirstOptionActive: true,
      onFocus: function () {
        this.close()
      },
      onType: function (str) {
        if (!str.length) {
          this.close()
          return
        }
        this.open()
      },
      render: {
        option_create: function (data, escape) {
          return '<div class="create">' + escape(data.input) + '</div>'
        },
        item: function () {
          return '<div style="display: none"></div>'
        }
      },
      onChange: function (value) {
        self.draftValues = value
        self.submitButtonTarget.disabled = false
        self.#render()
        this.close()
      },
      onDropdownOpen: function () {
        if (this.getTextboxValue().length === 0) {
          this.close();
        }
      },
    })

    this.#render()
  }

  apply() {
    this.selectedValue = this.draftValues
    this.draftValues = []
    this.submitButtonTarget.disabled = true
    this.#render()
    this.#dispatchFilterEvent()
  }

  clear() {
    this.selectedValue = []
    this.#render()
  }

  remove(event) {
    const alreadyFilteredBy = this.selectedOptionTargets.some(selectedOption => selectedOption.dataset.value === event.params.option)

    this.draftValues = this.draftValues.filter(value => value !== event.params.option)
    this.selectedValue = this.selectedValue.filter(value => value !== event.params.option)
    $(this.selectTarget).data().selectize.removeItem(event.params.option)

    this.#render()
    if (alreadyFilteredBy) {
      // We need to dispatch the filter to refresh the results
      this.#dispatchFilterEvent()
    }
  }


  #dispatchFilterEvent() {
    this.dispatch("filter", { detail: { name: "job_titles", values: this.selectedValue } })
  }

  #render() {
    this.listTarget.innerHTML = ""

    // Reset containers
    this.selectedOptionTargets.forEach(selectedOption => {
      selectedOption.remove()
    })

    this.buttonTarget.dataset.selectedFilters = this.selectedValue.length

    // Render items
    this.selectedValue.forEach(option => {
      this.#renderDropdownItem(option)
      this.#renderFilterValue(option)
    });

    this.draftValues.forEach(option => {
      if (!this.selectedValue.includes(option)) {
        this.#renderDropdownItem(option)
      }
    })
  }

  #renderDropdownItem(option) {
    const clone = this.tagTemplateTarget.content.cloneNode(true)
    const element = clone.firstElementChild
    element.innerHTML = element.innerHTML.replaceAll("$VALUE", option)
    this.listTarget.append(element)
  }

  #renderFilterValue(option) {
    const clone = this.selectedOptionTemplateTarget.content.cloneNode(true)

    // Replace the placeholder with the actual record ID
    const element = clone.firstElementChild
    element.dataset.value = option
    element.innerHTML = element.innerHTML.replaceAll("$VALUE", option)
    this.element.append(element)
  }
}
